// extracted by mini-css-extract-plugin
export var avatarContainer = "_5k-1";
export var largeAvatarContainer = "_5k-2";
export var smallAvatarContainer = "_5k-0";